__turbopack_context__.v({
  "thumbnail": "Thumbnail-module__d6cNgW__thumbnail",
});
